// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"EU1_thecomp__1owBx"};